<template>
  <section class="ann-contribute">
    <div class="ct-divider"></div>

    <div class="ct-main-btn flex-center btn" @click="emit('ignite')">
      {{ $t('ann2026.contribute.btnMain') }}
    </div>

    <img class="ct-fire" :src="fireImg" alt="fire" />

    <div class="ct-desc">
      <div>{{ $t('ann2026.contribute.desc1') }}</div>
      <div>{{ $t('ann2026.contribute.desc2').replace('_n', props.fireCount) }}</div>
    </div>

    <div class="ct-tab ct-tab--supply flex-center btn" @click="emit('supply')">
      {{ $t('ann2026.contribute.tabSupply') }}
    </div>
    <div class="ct-tab ct-tab--rally flex-center btn" @click="emit('rally')">
      {{ $t('ann2026.contribute.tabRally') }}
    </div>
    <div class="ct-tab ct-tab--history active flex-center btn" @click="emit('history')">
      {{ $t('ann2026.contribute.tabHistory') }}
    </div>

    <img
      v-if="props.showBadge"
      class="ct-badge"
      src="@/assets/imgs/act/ann2026/contribute/badge.png"
      alt="badge"
    />
  </section>
</template>

<script setup>
/* eslint-disable */
import { defineProps, defineEmits } from 'vue'
import fireImg from '@/assets/imgs/act/ann2026/contribute/fire.png'

const props = defineProps({
  // activityInfo.availableFireCount，未登录时传 0
  fireCount: { type: Number, default: 0 },
  // 有已完成但未领取的火力补给任务时为 true
  showBadge: { type: Boolean, default: false },
})
const emit = defineEmits(['ignite', 'supply', 'rally', 'history'])
</script>

<style lang="less" scoped>
// 区块范围：设计稿 848 ~ 1239，内部子元素绝对定位，坐标 = 设计稿 top - 848
// 底部分割线（1239）由 Milestone 区块的顶部分割线渲染，此处不重复
.ann-contribute {
  position: relative;
  width: 752px;
  height: 391px;
  background: transparent;
  overflow: hidden;

  > * {
    position: absolute;
  }
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ct-divider {
  left: 0;
  top: 0; // 848
  width: 752px;
  height: 74px;
  background-image: url('~@/assets/imgs/act/ann2026/common/divider.png');
  background-size: 752px 74px;
  background-repeat: no-repeat;
}

.ct-main-btn {
  // left: 170px;
  // top: 101px; // 949
  width: 436px;
  height: 112px;
  background-image: url('~@/assets/imgs/act/ann2026/contribute/btn-main.png');
  background-size: cover;
  background-repeat: no-repeat;
  margin: 0 auto;
  margin-top: 80px;
  font-size: 31px;
  font-weight: bold;
  color: #fe2cb9;
  cursor: pointer;
  position: static;
}

.ct-fire {
  left: 671px;
  top: 137px; // 985
  width: 81px;
  height: 181px;
}

.ct-desc {
  left: 170px;
  top: 206px; // 1054
  width: 413px;
  height: 42px;
  font-size: 18px;
  line-height: 21px;
  font-weight: bold;
  color: #fff;
  text-align: center;
}

.ct-tab {
  top: 276px; // 1124
  width: 176px;
  height: 80px;
  background-image: url('~@/assets/imgs/act/ann2026/contribute/btn-tab.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  font-size: 18px;
  line-height: 1.1;
  font-weight: bold;
  color: #fff;
  text-align: center;
  padding: 0 20px;
  box-sizing: border-box;
  cursor: pointer;

  &--supply {
    left: 86px;
  }

  &--rally {
    left: 292px;
  }

  &--history {
    left: 497px;
  }

  &.active {
    background-image: url('~@/assets/imgs/act/ann2026/contribute/btn-tab-active.png');
    color: #263278;
  }
}

.ct-badge {
  left: 200px;
  top: 229px; // 1117
  width: 109px;
  height: 109px;
  pointer-events: none;
}
</style>
